import styles from "./StatisticsDepositDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { StatisticDetailItemType } from "../../../common/labels";
import {
  formatSignedPrice,
  getAmountTone,
} from "../../../common/utilities/currencyUtility";
import { CurrencyType } from "../../../common/enums";
import { getDepositAmountWithCurrency } from "../utilities/depositAmountUtility";

interface IStatisticsDepositTransactionDialogProps {
  item: IStatisticDetailedItemViewModel;
}

// Drill-down card for a deposit ledger row ("Захранени депозити" /
// "Извадени депозити"): client, SIGNED colored amount (rendered in the row's
// own currency), comment, date, author.
export const StatisticsDepositTransactionDialog = ({
  item,
}: IStatisticsDepositTransactionDialogProps) => {
  const { amount, currencyId } = getDepositAmountWithCurrency(item) ?? {
    amount: 0,
    currencyId: CurrencyType.EUR,
  };
  const tone = getAmountTone(amount);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName}{" "}
            {item.userId > 0 && <span>(#{item.userId})</span>}
          </h5>
          <p>
            Дата: <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
        <div className={styles.root_header_right}>
          <span className={styles[`amount_${tone}`]}>
            {formatSignedPrice(amount, currencyId)}
          </span>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"СУМА"}
          value={
            <span className={styles[`amount_${tone}`]}>
              {formatSignedPrice(amount, currencyId)}
            </span>
          }
        />
        <StatisticsDialogKeyValueItem
          name={"ИЗВЪРШЕНО ОТ"}
          value={item.additionalTypeInfo ?? "—"}
        />
        <StatisticsDialogKeyValueItem
          name={"КОМЕНТАР"}
          value={item.name || "—"}
        />
        <StatisticsDialogKeyValueItem
          name={"ТИП ТРАНЗАКЦИЯ"}
          value={StatisticDetailItemType[item.type]}
        />
      </div>
    </div>
  );
};
